module.exports = __webpack_public_path__ + "static/media/2-outdoor.4003d30a.webp";